import { VariableDefinition } from '../../../../utils/variableExtraction';

/**
 * Deduplicate a list of variable definitions by name, keeping the first occurrence.
 *
 * Used by the Decision, Script, and related tabs that render a variables sidebar —
 * the incoming context can contain the same variable multiple times when a node
 * inherits context from several upstream branches.
 */
export const dedupeContextByName = (context: VariableDefinition[]): VariableDefinition[] =>
    context.filter((v, i, self) => i === self.findIndex((t) => t.name === v.name));
